module.exports = "/assets/data/cb569a726fc8c693f0476ace3b27b80d-B78.data.json";